import { connect } from 'react-redux';
import MobileFilterDrawer from './MobileFilterDrawer';
import { setMobileFilterDrawerOpen } from '../store/selfAuthorizationsSlice';

const mapState = state => ({
  mobileFilterDrawerOpen: state.loadingManagement.selfAuthorizations.mobileFilterDrawerOpen,
});

export default connect(mapState, { setMobileFilterDrawerOpen })(MobileFilterDrawer);
